// src/containers/Dockyard/styles/index.ts
import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useDockyardStyles = createUseStyles(() => ({
  form: {
    width: "100%",
    marginTop: theme.spacing?.(2) || "16px",
  },
  newFormFieldsRow: {
    display: "flex",
    gap: theme.spacing?.(2) || "16px",
    marginBottom: theme.spacing?.(2) || "16px",
  },
  newFormFieldsCol: {
    flex: 1,
  },
  newFormFieldSmallCol: {
    width: "120px",
  },
  errorField: {
    color: theme.color.red || "#d32f2f",
    marginTop: theme.spacing?.(1) || "8px",
  },
  // Keep the original footer form styles - don't change button separation
  footerForm: {
    display: "flex",
    justifyContent: "space-between", // Keep buttons separated
    marginTop: theme.spacing?.(3) || "24px",
    "& button:first-child": {
      marginRight: "auto", // Push cancel to left
    },
    "& button:last-child": {
      marginLeft: "auto", // Push submit to right
    },
  },
  ProjectsPage_Popin: {
    "& .MuiDrawer-paper": {
      width: "786px !important",
      overflowY: "unset !important",
    },
    "& .bordered": {
      display: "flex",
      alignItems: "center",
      borderTop: "1px solid #d8dadc",
      "& h3:not(:first-child)": {
        marginLeft: "10px",
      },
    },
  },
}));
